import { render, staticRenderFns } from "./Deposits.vue?vue&type=template&id=602e8c3e&scoped=true"
import script from "./Deposits.vue?vue&type=script&lang=js"
export * from "./Deposits.vue?vue&type=script&lang=js"
import style0 from "./Deposits.vue?vue&type=style&index=0&id=602e8c3e&prod&lang=scss"
import style1 from "./Deposits.vue?vue&type=style&index=1&id=602e8c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602e8c3e",
  null
  
)

export default component.exports